import {
  GlobalSearchRequestDto,
  GlobalSearchResponseDto,
} from 'switch-shared/modules/features/global-search/global-search.dto';

import { baseAPI } from './baseAPI.service';
import { API_METHODS, ENDPOINT_URLS } from './config/apiTags';

export const globalSearchAPI = baseAPI
  .enhanceEndpoints({
    addTagTypes: [ENDPOINT_URLS.GLOBAL_SEARCH],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      globalSearch: builder.query<
        GlobalSearchResponseDto,
        GlobalSearchRequestDto
      >({
        query: (params) => ({
          url: ENDPOINT_URLS.GLOBAL_SEARCH,
          method: API_METHODS.GET,
          params,
        }),
      }),
    }),
    overrideExisting: false,
  });

export const { useGlobalSearchQuery, useLazyGlobalSearchQuery } =
  globalSearchAPI;
